@defer (hydrate on immediate) {
	<div class="flex flex-col">
		<div class="relative">
			<div class="relative w-full z-[-999]">
				<img
					src="/assets/images/headers/desktop/header_pokemon_desktop.png"
					class="w-full h-[850px] object-cover hidden md:block"
					alt="Header Pokemon"
				/>
				<img
					src="/assets/images/headers/mobile/header_pokemon_mobile.png"
					class="w-full h-[850px] object-cover block md:hidden"
					alt="Header Pokemon"
				/>
			</div>
			<peps-separator></peps-separator>
		</div>
	</div>

	<section class="relative flex flex-col gap-24 lg:gap-40 mb-24 px-6 lg:px-20 max-w-[1400px] mx-auto mt-10">
		<!-- Ligne de timeline -->
		<div class="hidden lg:block absolute left-1/2 top-0 bottom-[28rem] w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-peps-gold/40 to-transparent"></div>

		@for (block of storyBlocks; track block.image; let i = $index; let odd = $odd) {
			<article class="group relative grid lg:grid-cols-2 gap-8 lg:gap-24 items-center">
				<!-- Pastille numérotée sur la ligne -->
				<span class="hidden lg:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 size-14 items-center justify-center rounded-full bg-peps-gold text-white font-dinpro-bold text-lg ring-8 ring-peps-gold/10 transition-transform duration-500 group-hover:scale-125">
					{{ block.year }}
				</span>

				<!-- Image -->
				<div class="relative" [class.lg:order-2]="odd">
					<div class="absolute inset-0 translate-x-3 translate-y-3 lg:translate-x-5 lg:translate-y-5 border-2 border-peps-gold/40 transition-transform duration-700 group-hover:translate-x-1 group-hover:translate-y-1"></div>
					<div class="relative overflow-hidden shadow-2xl">
						<img
							[src]="block.image"
							[alt]="block.label | translate"
							loading="lazy"
							class="w-full h-auto block transition-transform duration-[1500ms] ease-in-out group-hover:scale-105"
						>
					</div>
				</div>

				<!-- Texte -->
				<div class="flex flex-col gap-5" [class.lg:order-1]="odd" [class.lg:text-right]="odd" [class.lg:items-end]="odd">
					<span class="lg:hidden font-dinpro-bold text-5xl opacity-30">0{{ i + 1 }}</span>
					<h2 class="text-4xl sm:text-6xl uppercase leading-none">{{ block.label | translate }}</h2>
					<div class="h-1 w-16 bg-peps-dark-200 transition-all duration-500 group-hover:w-32"></div>
					<p class="font-notosans text-lg leading-relaxed whitespace-pre-line">{{ block.text | translate }}</p>
				</div>
			</article>
		}

		<!-- Conclusion : texte superposé à l'image, image affichée en entier -->
		<div class="relative overflow-hidden shadow-2xl">
			<img
				src="/assets/images/unite/unite_1.png"
				alt="Team Peps Pokémon Unite"
				loading="lazy"
				class="w-full h-auto block"
			>
			<div class="absolute inset-x-0 bottom-0 flex flex-col items-center gap-2 sm:gap-4 px-6 pt-24 pb-6 sm:pb-10 text-center text-white bg-gradient-to-t from-black/80 via-black/40 to-transparent">
				<p class="font-notosans text-sm sm:text-xl max-w-2xl">{{ 'page.roster-pokemon-unite.thanks' | translate }}</p>
				<p class="text-3xl sm:text-7xl uppercase">#AuxArmes ⚔️</p>
			</div>
		</div>
	</section>

	<peps-last-videos></peps-last-videos>
}
